import moment from "moment";

export function momentFilter() {
  function filter(momentObj, format){
    if(!momentObj)
      return '';
    if(!moment.isMoment(momentObj))
      if(angular.isDate(momentObj))
        momentObj = moment(momentObj);
      else
        return '';
    var language = localStorage.getItem('roedl-language');
    if(format == 'fromNow')
      return momentObj.locale(language).fromNow();
    else
      return momentObj.locale(language).format(format);
  }
  filter.$stateful = true;
  return filter;
}
